/** Minimum trimmed length before patient/lead search APIs are called. */
export const MIN_LEAD_SEARCH_LENGTH = 3;

/** True when a trimmed search string is long enough to query the backend. */
export function isSearchQueryReady(
  query: string,
  minLength: number = MIN_LEAD_SEARCH_LENGTH
): boolean {
  return query.trim().length >= minLength;
}

/** Trimmed search for API params, or undefined when below minimum length. */
export function searchQueryForApi(
  query: string,
  minLength: number = MIN_LEAD_SEARCH_LENGTH
): string | undefined {
  const trimmed = query.trim();
  return isSearchQueryReady(trimmed, minLength) ? trimmed : undefined;
}
